
import { timeParse } from "d3-time-format";
import { tsvParse, csvParse } from  "d3-dsv";
function parseData(parse) {
	return function(d) {
		d.date = parse(d.tick_time_stamp);
		d.open = +d.open;
		d.high = +d.high;
		d.low = +d.low;
		d.close = +d.close;
		d.volume = +d.volume;

		return d;
	};
}

const parseDateTime = timeParse("%Y-%m-%d %H:%M:%S");

export function getData() {
	const uri = process.env.REACT_APP_API_ENDPOINT
          ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
          : "";
	const promiseMSFT = fetch(`${uri}api/optionData?symbol=NIFTY%20BANK&expiry=2023-08-24&optionName=BANKNIFTY2382444700PE`)
		.then(response => response.text())
		.then(data => csvParse(data, parseData(parseDateTime)))
	return promiseMSFT;
}
